import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const QUERY_BUILDER_REQUEST = 'QUERY_BUILDER_REQUEST';
export const QUERY_BUILDER_SUCCESS = 'QUERY_BUILDER_SUCCESS';
export const QUERY_BUILDER_FAILURE = 'QUERY_BUILDER_FAILURE';

export const QUERY_BUILDER_SEARCH_REQUEST = 'QUERY_BUILDER_SEARCH_REQUEST';
export const QUERY_BUILDER_SEARCH_SUCCESS = 'QUERY_BUILDER_SEARCH_SUCCESS';
export const QUERY_BUILDER_SEARCH_FAILURE = 'QUERY_BUILDER_SEARCH_FAILURE';

export const QUERY_BUILDER_TYPEAHEAD_REQUEST =
  'QUERY_BUILDER_TYPEAHEAD_REQUEST';
export const QUERY_BUILDER_TYPEAHEAD_SUCCESS =
  'QUERY_BUILDER_TYPEAHEAD_SUCCESS';
export const QUERY_BUILDER_TYPEAHEAD_FAILURE =
  'QUERY_BUILDER_TYPEAHEAD_FAILURE';

export const QUERY_BUILDER_QUERIES_REQUEST = 'QUERY_BUILDER_QUERIES_REQUEST';
export const QUERY_BUILDER_QUERIES_SUCCESS = 'QUERY_BUILDER_QUERIES_SUCCESS';
export const QUERY_BUILDER_QUERIES_FAILURE = 'QUERY_BUILDER_QUERIES_FAILURE';

export const QUERY_BUILDER_ADD_QUERY_REQUEST =
  'QUERY_BUILDER_ADD_QUERY_REQUEST';
export const QUERY_BUILDER_ADD_QUERY_SUCCESS =
  'QUERY_BUILDER_ADD_QUERY_SUCCESS';
export const QUERY_BUILDER_ADD_QUERY_FAILURE =
  'QUERY_BUILDER_ADD_QUERY_FAILURE';

export const QUERY_BUILDER_DELETE_QUERY_REQUEST =
  'QUERY_BUILDER_DELETE_QUERY_REQUEST';
export const QUERY_BUILDER_DELETE_QUERY_SUCCESS =
  'QUERY_BUILDER_DELETE_QUERY_SUCCESS';
export const QUERY_BUILDER_DELETE_QUERY_FAILURE =
  'QUERY_BUILDER_DELETE_QUERY_FAILURE';

export function requestQueryBuilderData(params = {}) {
  const query = $.param({ ...params, target: 'patient' });
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/query-builder/data?${query}`,
      method: 'GET',
      types: [
        'QUERY_BUILDER_REQUEST',
        'QUERY_BUILDER_SUCCESS',
        'QUERY_BUILDER_FAILURE',
      ],
    },
  };
}

export function performSearch(data, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/search/patients?${query}`,
      method: 'POST',
      body: data,
      types: [
        'QUERY_BUILDER_SEARCH_REQUEST',
        'QUERY_BUILDER_SEARCH_SUCCESS',
        'QUERY_BUILDER_SEARCH_FAILURE',
      ],
    },
  };
}

export function requestTypeahead(url, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${url}?${query}`,
      method: 'GET',
      types: [
        'QUERY_BUILDER_TYPEAHEAD_REQUEST',
        'QUERY_BUILDER_TYPEAHEAD_SUCCESS',
        'QUERY_BUILDER_TYPEAHEAD_FAILURE',
      ],
    },
  };
}

export function requestQueries(userID, params = {}) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userID}/queries`,
      method: 'GET',
      types: [
        QUERY_BUILDER_QUERIES_REQUEST,
        QUERY_BUILDER_QUERIES_SUCCESS,
        QUERY_BUILDER_QUERIES_FAILURE,
      ],
    },
  };
}

export function addQuery(userID, body) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userID}/queries`,
      method: 'POST',
      body: JSON.stringify(body),
      types: [
        QUERY_BUILDER_ADD_QUERY_REQUEST,
        QUERY_BUILDER_ADD_QUERY_SUCCESS,
        QUERY_BUILDER_ADD_QUERY_FAILURE,
      ],
    },
  };
}

export function updateQuery(userID, body) {
  console.log(userID, body);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userID}/queries/${body.id}`,
      method: 'PUT',
      body: JSON.stringify(body),
      types: [
        QUERY_BUILDER_ADD_QUERY_REQUEST,
        QUERY_BUILDER_ADD_QUERY_SUCCESS,
        QUERY_BUILDER_ADD_QUERY_FAILURE,
      ],
    },
  };
}

export function deleteQuery(userID, queryID, params = {}) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userID}/queries/${queryID}`,
      method: 'DELETE',
      types: [
        QUERY_BUILDER_DELETE_QUERY_REQUEST,
        QUERY_BUILDER_DELETE_QUERY_SUCCESS,
        QUERY_BUILDER_DELETE_QUERY_FAILURE,
      ],
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/query-builder/QueryBuilderActions.js